/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports

import LogRocket from 'logrocket';
LogRocket.init('vgd7eb/clean-intel');

import Vue from 'vue';
import Vuex from 'vuex';

// Store functionality
import actions from './actions';
import getters from './getters';
import modules from './modules';
import mutations from './mutations';
import state from './state';

// Vuex mutation logging on LogRocket
import createPlugin from 'logrocket-vuex';

Vue.use(Vuex);

const logrocketPlugin = createPlugin(LogRocket);

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state,
  plugins: [logrocketPlugin],
});

export default store;
